var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAddImages = function SvgAddImages(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2222 1H2.77778C1.79594 1 1 1.79594 1 2.77778V15.2222C1 16.2041 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.2041 17 15.2222V2.77778C17 1.79594 16.2041 1 15.2222 1Z",
    stroke: "#7D86A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.889 7.22221C6.62538 7.22221 7.22233 6.62526 7.22233 5.88888C7.22233 5.1525 6.62538 4.55554 5.889 4.55554C5.15262 4.55554 4.55566 5.1525 4.55566 5.88888C4.55566 6.62526 5.15262 7.22221 5.889 7.22221Z",
    stroke: "#7D86A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0001 11.6667L12.5556 7.22229L7.66672 12.1112L2.77783 17.0001",
    stroke: "#7D86A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2222 8.99988H10.7778C9.79594 8.99988 9 9.79582 9 10.7777V23.2221C9 24.2039 9.79594 24.9999 10.7778 24.9999H23.2222C24.2041 24.9999 25 24.2039 25 23.2221V10.7777C25 9.79582 24.2041 8.99988 23.2222 8.99988Z",
    fill: "#F4F6FB",
    stroke: "#7D86A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.889 15.222C14.6254 15.222 15.2223 14.625 15.2223 13.8886C15.2223 13.1523 14.6254 12.5553 13.889 12.5553C13.1526 12.5553 12.5557 13.1523 12.5557 13.8886C12.5557 14.625 13.1526 15.222 13.889 15.222Z",
    fill: "#F4F6FB",
    stroke: "#7D86A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 19.6665L20.5554 15.222L10.7776 24.9998",
    fill: "#F4F6FB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 19.6665L20.5554 15.222L10.7776 24.9998",
    stroke: "#7D86A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddImages, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add_images.48bce237.svg";
export { ForwardRef as ReactComponent };